import React from "react";
import Chip from "../Chip";
import MUIGreyColor from "@mui/material/colors/grey";
import MUIAvatar from "@mui/material/Avatar";
import MarketingCampaignCategory from "../../Utility/Crud/MarketingCampaignCategory";

export default class ChipMarketingCampaignCategory extends Chip {
    /**
     * Renders a MUI Avatar.
     */
    renderAvatar() {
        const color = (this.props.marketingCampaignCategory ? MarketingCampaignCategory.getColor() : MUIGreyColor[500]);
        const avatarColor = this.props.isTransparent ? "transparent" : color;
        const iconColor = this.props.isTransparent ? color : "#fff";

        return (
            <MUIAvatar sx={{ bgcolor: avatarColor }}>
                {MarketingCampaignCategory.getIcon({ fontSize: "small", sx: { color: iconColor } })}
            </MUIAvatar>
        );
    }

    /**
     * @return {string} The marketingCampaignCategory name.
     */
    getLabel() {
        return this.props.marketingCampaignCategory ? MarketingCampaignCategory.getDisplayName(this.props.marketingCampaignCategory) : "None";
    }
}
